import {
   context$,
   groups$,
   homeScreenLayout$,
   includeSubsidiaries$,
   language$,
   layouts$,
   loading$,
   locale$,
   note$,
   notifications$,
   organisations$,
   organisationsViewOrder$,
   organisationTreeExpandedItemIds$,
   pageSize$,
   reducedContext$,
   reportEditorMergeFieldsPreviewMode$,
   reportingPeriods$,
   reportingStandards$,
   rules$,
   supportedLanguage$,
   userContextQuery,
   userId$,
} from 'context/UserContext/query';
import store from 'context/UserContext/store';
import OrganisationsService from 'state/Organisations/service';
import UsersService from 'state/User/service';

const api = new UsersService();
const organisationsAPI = new OrganisationsService();

const facade = {
   api,
   context$,
   groups$,
   homeScreenLayout$,
   includeSubsidiaries$,
   language$,
   layouts$,
   loading$,
   locale$,
   note$,
   organisationTreeExpandedItemIds$,
   notifications$,
   organisations$,
   organisationsAPI,
   pageSize$,
   query: userContextQuery,
   reducedContext$,
   reportEditorMergeFieldsPreviewMode$,
   reportingPeriods$,
   reportingStandards$,
   rules$,
   store,
   supportedLanguage$,
   organisationsViewOrder$,
   userId$,
};

export default facade;
